import { render, staticRenderFns } from "./UserProfileSlider.vue?vue&type=template&id=1f94725b&scoped=true&"
import script from "./UserProfileSlider.vue?vue&type=script&lang=js&"
export * from "./UserProfileSlider.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileSlider.vue?vue&type=style&index=0&id=1f94725b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f94725b",
  null
  
)

export default component.exports